import { render } from "./CurrentQuestion.vue?vue&type=template&id=01ea2e78&scoped=true"
import script from "./CurrentQuestion.vue?vue&type=script&lang=js"
export * from "./CurrentQuestion.vue?vue&type=script&lang=js"

import "./CurrentQuestion.vue?vue&type=style&index=0&id=01ea2e78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ea2e78"]])

export default __exports__